function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class AnnouncementBar extends HTMLElement {
  constructor() {
    super();

    this.items = this.querySelectorAll('.announcement-bar__item');
    this.itemsWrapper = this.querySelector('.announcement-bar--wrapper');
    this.transitionDelay = this.dataset.transitionDelay * 1000 || 5000;
    this.pauseOnHover = this.dataset.pauseOnHover || true;
  }

  moveSlides = () => {
    const firstItem = this.items[0];
    this.itemsWrapper.classList.add('announcement-bar--animate');
    this.itemsWrapper.style.transform = `translateX(-${firstItem.clientWidth}px)`;
  }

  moveSlideEnd = () => {
    this.itemsWrapper.classList.remove('announcement-bar--animate');
    const firstItem = this.items[0];
    this.items[0].remove();
    this.itemsWrapper.appendChild(firstItem);
    this.itemsWrapper.style.transform = 'translateX(0)';
    this.items = this.querySelectorAll('.announcement-bar__item');
  }

  connectedCallback() {
    if (this.items.length > 1) {
      this.interval = setInterval(this.moveSlides, this.transitionDelay);
      this.itemsWrapper.addEventListener('transitionend', this.moveSlideEnd);
      if (this.pauseOnHover) {
        this.itemsWrapper.addEventListener('mouseenter', () => clearInterval(this.interval));
        this.itemsWrapper.addEventListener('mouseleave', () => this.interval = setInterval(this.moveSlides, this.transitionDelay));
      }
    }
  }
}

customElements.define('announcement-bar', AnnouncementBar);

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();

    this.header = document.querySelector('.section-header');
    this.annoucementBar = document.querySelector('.announcement-bar-section');
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button:not(.localization-selector)').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle && !this.closest('#mobilemenu')) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    if (this.header) {
      this.header.classList.add('reset-z-index');
    }
    if (this.annoucementBar) {
      this.annoucementBar.classList.add('reset-z-index');
    }
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
    setTimeout(() => {
      if (this.header) {
        this.header.classList.remove('reset-z-index');
      }
      if (this.annoucementBar) {
        this.annoucementBar.classList.remove('reset-z-index');
      }
    }, 400)
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement?.closest('.submenu-open');
    if(!parentMenuElement) return;
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  /*
  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }
  */

  onResize = () => {
    this.header && document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('mobile-menu-nav', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));

      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.pageNav = this.querySelector('.slider-counter--nav');
    this.sliderDots = this.querySelectorAll('.slider-counter--nav .slider-counter--dot-button');
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    if (this.pageNav && this.sliderDots) {
      this.sliderDots.forEach((dot) =>
        dot.addEventListener('click', this.onButtonClick.bind(this))
      );
    }

    this.progressBar = this.querySelector('.progress-bar__fill');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.updateNav(this.totalPages)
    this.update();
  }

  updateNav(items) {
    if (!this.pageNav) return;

    let totalDots = items;
    for (let i = 0; i < this.pageNav.children.length; i++) {
      let tableChild = this.pageNav.children[i];
      tableChild.classList.add('hidden');
    }
    if (totalDots > this.pageNav.children.length) {
      totalDots = this.pageNav.children.length
    }
    for (let i = 0; i < totalDots; i++){
      this.pageNav.getElementsByClassName(`dot-${i+1}`)[0].classList.remove('hidden');
    }
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1]) && this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.nextButton.classList.add('visually-hidden');
      this.prevButton.classList.add('visually-hidden');
    } else {
      this.nextButton.classList.remove('visually-hidden');
      this.prevButton.classList.remove('visually-hidden');
    }

    if (this.pageNav && this.sliderDots) {
      for (let i = 0; i < this.pageNav.children.length; i++) {
        let tableChild = this.pageNav.children[i];
        tableChild.classList.remove('active');
      }
      this.pageNav.getElementsByClassName(`dot-${this.currentPage}`)[0].classList.add('active');
    }

    if(this.progressBar) {
      this.updateProgressBarPosition();
    }

  }

  updateProgressBarPosition() {
    requestAnimationFrame(() => {
      const scrolled = this.slider.scrollLeft;
      const total = this.slider.scrollWidth - this.slider.clientWidth;
      const percent = (scrolled / total) * 100;
      this.progressBar.style.left = `${percent - (percent / this.sliderItems.length)}%`;
    })
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const currentTarget = event.currentTarget;
    const currentActive = currentTarget.parentElement.querySelector('.slider-counter--dot-button.active');
    let step = parseInt(event.currentTarget.dataset.step) || 1;
    if (currentTarget.classList.contains('slider-counter--dot-button')) {
      if (!currentTarget.classList.contains('active')) {
        let currentStep = parseInt(currentActive.dataset.step);
        if (step > currentStep) {
          let position = step - currentStep
          this.slideScrollPosition = (position * this.sliderItemOffset) + this.slider.scrollLeft;
        } else {
          let position = currentStep - step
          this.slideScrollPosition = this.slider.scrollLeft - (position* this.sliderItemOffset);
        }
      }
    } else {
      this.slideScrollPosition = currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    }

    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  mouseDownHandler(e) {
    this.slider.classList.add('grabbing');
    this.slider.style.userSelect = 'none';

    const pos = {
      left: this.slider.scrollLeft,
      top: this.slider.scrollTop,
      x: e.clientX,
      y: e.clientY
    };

    const mouseMoveHandler = (e) => {
      const dx = e.clientX - pos.x;
      const dy = e.clientY - pos.y;

      this.slider.scrollTop = pos.top - dy;
      this.slider.scrollLeft = pos.left - dx;
    };

    const mouseUpHandler = () => {
      this.slider.classList.remove('grabbing');
      this.slider.style.removeProperty('user-select');

      document.removeEventListener('mousemove', mouseMoveHandler);
      document.removeEventListener('mouseup', mouseUpHandler);
    };

    document.addEventListener('mousemove', mouseMoveHandler);
    document.addEventListener('mouseup', mouseUpHandler);
  }

  connectedCallback() {
    // Fix a bug where carousels are sometimes scrolled to the far left on page load
    if( this.dataset.reset_scroll == "true" ) {
      this.slider.scrollLeft = 0;
    }
    // disabling drag slide change implemented on desktop as it's a little junky
    // this.slider.addEventListener('mousedown', this.mouseDownHandler.bind(this));
  }

  disconnectedCallback() {
    // this.slider.removeEventListener('mousedown', this.mouseDownHandler.bind(this));
  }

}

customElements.define('slider-component', SliderComponent);

class SliderComponentCard extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="SliderCard-"]');
    this.sliderItems = this.querySelectorAll('[id^="SlideCard-"]');
    this.enableSliderLooping = false;
    this.pageNav = this.querySelector('.product-slider-counter--nav');
    this.sliderDots = this.querySelectorAll('.product-slider-counter--nav .slider-counter--dot-button');
    this.currentPageElement = this.querySelector('.product-card-gallery .slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous-card"]');
    this.nextButton = this.querySelector('button[name="next-card"]');
    if (this.pageNav && this.sliderDots) {
      this.sliderDots.forEach((dot) =>
        dot.addEventListener('click', this.onButtonClick.bind(this))
      );
    }

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.updateNav(this.totalPages)
    this.update();
  }

  updateNav(items) {
    if (!this.pageNav) return;

    let totalDots = items;
    for (let i = 0; i < this.pageNav.children.length; i++) {
      let tableChild = this.pageNav.children[i];
      tableChild.classList.add('hidden');
    }
    if (totalDots > this.pageNav.children.length) {
      totalDots = this.pageNav.children.length
    }
    for (let i = 0; i < totalDots; i++){
      this.pageNav.getElementsByClassName(`dot-card-${i+1}`)[0].classList.remove('hidden');
    }
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="SlideCard-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    if (this.pageNav && this.sliderDots) {
      for (let i = 0; i < this.pageNav.children.length; i++) {
        let tableChild = this.pageNav.children[i];
        tableChild.classList.remove('active');
      }

      if (this.pageNav.getElementsByClassName(`dot-card-${this.currentPage}`)[0]) {
        this.pageNav.getElementsByClassName(`dot-card-${this.currentPage}`)[0].classList.add('active');
      }
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const currentTarget = event.currentTarget;
    const currentActive = currentTarget.parentElement.querySelector('.product-slider-counter--dot-button.active');
    let step = parseInt(event.currentTarget.dataset.step) || 1;
    if (currentTarget.classList.contains('slider-counter--dot-button')) {
      if (!currentTarget.classList.contains('active')) {
        let currentStep = parseInt(currentActive.dataset.step);
        if (step > currentStep) {
          let position = step - currentStep
          this.slideScrollPosition = (position * this.sliderItemOffset) + this.slider.scrollLeft;
        } else {
          let position = currentStep - step
          this.slideScrollPosition = this.slider.scrollLeft - (position* this.sliderItemOffset);
        }
      }
    } else {
      this.slideScrollPosition = currentTarget.name === 'next-card' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    }

    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  mouseDownHandler(e) {
    this.slider.classList.add('grabbing');
    this.slider.style.userSelect = 'none';

    const pos = {
      left: this.slider.scrollLeft,
      top: this.slider.scrollTop,
      x: e.clientX,
      y: e.clientY
    };

    const mouseMoveHandler = (e) => {
      const dx = e.clientX - pos.x;
      const dy = e.clientY - pos.y;

      this.slider.scrollTop = pos.top - dy;
      this.slider.scrollLeft = pos.left - dx;
    };

    const mouseUpHandler = () => {
      this.slider.classList.remove('grabbing');
      this.slider.style.removeProperty('user-select');

      document.removeEventListener('mousemove', mouseMoveHandler);
      document.removeEventListener('mouseup', mouseUpHandler);
    };

    document.addEventListener('mousemove', mouseMoveHandler);
    document.addEventListener('mouseup', mouseUpHandler);
  }

  connectedCallback() {
    // Fix a bug where carousels are sometimes scrolled to the far left on page load
    if( this.dataset.reset_scroll == "true" ) {
      this.slider.scrollLeft = 0;
    }
    // disabling drag slide change implemented on desktop as it's a little junky
    // this.slider.addEventListener('mousedown', this.mouseDownHandler.bind(this));
  }

  disconnectedCallback() {
    // this.slider.removeEventListener('mousedown', this.mouseDownHandler.bind(this));
  }

}

customElements.define('slider-card', SliderComponentCard);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();

    document.querySelectorAll('.product-form__input input[type="radio"], .product-form__input select').forEach((option) =>
      option.addEventListener('change', this.whichInputUpdated.bind(option))
    )

    this.addEventListener('change', this.onVariantChange);
  }

  whichInputUpdated(element){

    var optionname = element.target.closest('.product-form__input').querySelector('.form__label').dataset.optionname;

    document.querySelectorAll(`.product-form__input`).forEach((option) =>
      option.classList.remove('activeset')
    );

    document.querySelectorAll(`.form__label[data-optionname="${optionname}"]`).forEach((option) =>
      option.closest('.product-form__input').classList.add('activeset')
    );

  }

  onVariantChange() {

    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }


    var allSelectors = document.querySelectorAll('.section-main-product .product__variant-selector.option-select');

    allSelectors.forEach((selector) => {
      if(selector != this){
        this.updatePairUI(selector, this);
      }
    });


  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {

      const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);

      const inputWrappers = [...this.querySelectorAll('.product-form__input')];

      inputWrappers.forEach((option, index) => {
        if (index === 0) return;
        const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
        const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
        const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
        this.setInputAvailability(optionInputs, availableOptionInputsValue)
      });

  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const destinationSticky = document.getElementById(`price-${this.dataset.section}-support`);

        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const sourceSticky = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}-support`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (sourceSticky && destinationSticky) destinationSticky.innerHTML = sourceSticky.innerHTML;

        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);
        const priceSticky = document.getElementById(`price-${this.dataset.section}-support`);

        if (price) price.classList.remove('visibility-hidden');
        if (priceSticky) priceSticky.classList.remove('visibility-hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);

        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);

        publish(PUB_SUB_EVENTS.variantChange, {data: {
          sectionId,
          html,
          variant: this.currentVariant
        }});

      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);

    if (!productForm) return;

    const stickyAtcButton = document.getElementById(`sticky-${this.dataset.section}`);

    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    const addButtonSticky = stickyAtcButton?.querySelector('[name="add"]');
    const addButtonTextSticky = stickyAtcButton?.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (addButtonSticky) addButtonSticky.setAttribute('disabled', 'disabled');
      if (text){
        addButtonText.textContent = text;
        if (addButtonSticky) addButtonTextSticky.textContent = text
      };
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;

      if (addButtonSticky){
        addButtonSticky.removeAttribute('disabled');
        addButtonTextSticky.textContent = window.variantStrings.addToCart
      };
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const stickyAtcButton = document.getElementById(`sticky-${this.dataset.section}`);

    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');

    const addButtonSticky = stickyAtcButton?.querySelector('[name="add"]');
    const addButtonTextSticky = stickyAtcButton?.querySelector('[name="add"] > span');

    const price = document.getElementById(`price-${this.dataset.section}`);
    const priceSticky = document.getElementById(`price-${this.dataset.section}-support`);

    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;

    if (addButtonSticky) addButtonTextSticky.textContent = window.variantStrings.unavailable;

    if (price) price.classList.add('visibility-hidden');
    if (priceSticky) priceSticky.classList.add('visibility-hidden');

    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updatePairUI(paired, original){

    var originalTagName = original.tagName.toLowerCase();
    var pairedTagName = paired.tagName.toLowerCase();
    var originalSelectedItem = '';
    var originalSelectedItemValue = '';

    if(originalTagName.includes("selects")){
      var itemSelect = original.querySelector('.activeset select');
      originalSelectedItem = itemSelect.options[itemSelect.selectedIndex];
      originalSelectedItemValue = originalSelectedItem.value;
    }else{
      originalSelectedItem = original.querySelector('.activeset input[type="radio"]:checked');
      originalSelectedItemValue = originalSelectedItem.value;
    }

    if(pairedTagName.includes("selects")){
      var event = new Event('change');
      paired.querySelector('.activeset select').value = originalSelectedItemValue;
      paired.querySelector(`.activeset option[data-value="${originalSelectedItemValue}"`).click()
      paired.dispatchEvent(event);
    }else{
      paired.querySelector(`.activeset input[type="radio"]:checked`).checked = false;
      var newTarget = paired.querySelector(`.activeset label[data-value="${originalSelectedItemValue}"`).getAttribute('for');
      paired.querySelector(`.activeset input[type="radio"]#${newTarget}`).checked = true;
    }

  }

}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          // Number of cards loaded will be cards.length
          const cards = html.querySelectorAll('.grid__item');

          // When the section is re-loaded with products, liquid within cannot reach the outer feature wrap element
          // Need to add fit-exactly classes with js depending on how many products are loaded
          // With the extra class a width for showing an extra quarter or half overrides the exact fit width
          const feature_card_enabled = this.dataset.feature_card_enabled === 'true';
          if( feature_card_enabled ) {
            const columns_desktop = parseInt(this.dataset.columns_desktop);
            const cards_fit_desktop = cards.length <= columns_desktop;
            const feature_wrap_el = document.querySelector(`#shopify-section-${this.dataset.section_id} .carousel__feature-wrap`);
            if( cards_fit_desktop ) {
              feature_wrap_el.classList.add('carousel__feature-wrap--cards-fit-desktop');
            }
          }

          const parent_section = document.getElementById(this.dataset.section_id);

          // Need to check recently tab before hiding the whole thing
          const hide_recently_tab = this.dataset.hide_recently_tab === 'true';
          const product_handle = this.dataset.product_handle
          const product_handles_list = localStorage.getItem("shopify_recently_viewed");
          const no_recently_viewed = ( !product_handles_list || product_handles_list == "" || product_handles_list == product_handle );

          if (cards) {

            // Loaded
            this.classList.add('product-recommendations--loaded');

          } else if( hide_recently_tab || no_recently_viewed ) {

            // No items - recently not showing - hide the carousel
            if( parent_section ) {
              parent_section.classList.add('hidden');
            }
          } else {
            // hide just product recommendations
            // hide both tabs
            const recommendations = parent_section.querySelector('product-recommendations');
            const recently = parent_section.querySelector('recently-viewed');
            const recommendations_tab = parent_section.querySelector('.product-recommendations-tab');
            const recently_tab = parent_section.querySelector('.recently-viewed-tab');

            recommendations_tab.classList.add('hidden');
            recently_tab.classList.add('hidden');
            recommendations.classList.remove('active');
            recently.classList.add('active');

          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);





class UpsellProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {

          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('upsell-product-recommendations');

          if (recommendations) {
            if(recommendations.innerHTML.trim().length == 0){
              fetch(this.dataset.fallbackurl)
              .then(response => response.text())
              .then(text => {
                html.innerHTML = text;
                const recommendations = html.querySelector('upsell-product-recommendations');
                this.innerHTML = recommendations.innerHTML;
                if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
                  this.remove();
                }
                if (html.querySelector('.grid__item')) {
                  this.classList.add('product-recommendations--loaded');
                }
              });
            }else{
              this.innerHTML = recommendations.innerHTML;
              if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
                this.remove();
              }
              if (html.querySelector('.grid__item')) {
                this.classList.add('product-recommendations--loaded');
              }
            }
          }

        })
        .catch(e => {
          console.error(e);
        });

  }
}

customElements.define('upsell-product-recommendations', UpsellProductRecommendations);


class CrossellProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {

          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('crossell-product-recommendations');

          if (recommendations) {
            if(recommendations.innerHTML.trim().length == 0){
              fetch(this.dataset.fallbackurl)
              .then(response => response.text())
              .then(text => {
                html.innerHTML = text;
                const recommendations = html.querySelector('crossel-product-recommendations');
                this.innerHTML = recommendations.innerHTML;
                if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
                  this.remove();
                }
                if (html.querySelector('.grid__item')) {
                  this.classList.add('product-recommendations--loaded');
                }
              });
            }else{
              this.innerHTML = recommendations.innerHTML;
              if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
                this.remove();
              }
              if (html.querySelector('.grid__item')) {
                this.classList.add('product-recommendations--loaded');
              }
            }
          }

        })
        .catch(e => {
          console.error(e);
        });

  }
}

customElements.define('crossell-product-recommendations', CrossellProductRecommendations);


class ShopTheLook extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('shop-look');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('shop-look--loaded');
          }

          var shopLookSlider = this.querySelector('shop-look ul.slider');
          var shopLookSliderChildren = shopLookSlider.querySelectorAll('.grid__item.slider__slide');

          if(shopLookSliderChildren.length > 0 || Shopify.designMode ){
            this.closest('.carousel').classList.remove('hidden');
          }else{
            this.closest('.carousel').classList.add('hidden');
          }

        })
        .catch(e => {
          console.error(e);
        });

  }
}

customElements.define('shop-look', ShopTheLook);


class RecentlyViewed extends HTMLElement {
  /*
    data-full_width="{{ full_width }}"
    data-max_cards_to_output="{{ max_cards_to_output }}"
    data-sectionid="{{ section.id }}"
    data-columns_desktop="{{ columns_desktop }}"
    data-columns_mobile="{{ columns_mobile }}"
    data-feature_card_enabled="{{ section.settings.feature_card_enabled }}"
    data-recently_is_only_tab="{{ recently_is_only_tab }}"
    data-on_product_page="{{ on_product_page }}"
  */

  constructor() {

    super();
  }

  config = {
    maxToShow: parseInt(this.dataset.max_cards_to_output),
    minToShow: 1,
    howManyToStoreInMemory: parseInt(this.dataset.max_cards_to_output),
    numberProducts: 0,
    onComplete: null
  };
  productHandleQueue = [];

  cookie = {
    name: 'shopify_recently_viewed',
    write: function (recentlyViewed) {
      localStorage.setItem(this.name, recentlyViewed.join(','));
    },
    read: function () {
      let recentlyViewed = [];
      let cookieValue = localStorage.getItem(this.name);
      if (cookieValue) {
        recentlyViewed = cookieValue.split(',');
      }
      return recentlyViewed;
    },
    destroy: function () {
      localStorage.removeItem(this.name);
    },
    remove: function (productHandle) {
      let recentlyViewed = this.read();
      let position = recentlyViewed.indexOf(productHandle);
      if (position !== -1) {
        recentlyViewed.splice(position, 1);
        this.write(recentlyViewed);
      }
    }
  };

  finalize = () => {

    // Add and remove classes that depend on the number of cards

    // Get elements
    const sliderComponent = this.querySelector('slider-component');
    const sliderUL = this.querySelector('slider-component ul.slider');
    const featureWrap = document.querySelector(`#shopify-section-${this.dataset.section_id}.carousel__feature-wrap`);
    const max_cards_to_output = this.config.maxToShow;

    // Hide buttons if cards fit
    const columns_desktop = parseInt(this.dataset.columns_desktop);
    const columns_mobile = parseInt(this.dataset.columns_mobile);
    let cards_fit_desktop = sliderUL.children.length <= columns_desktop;
    const cards_fit_mobile = sliderUL.children.length <= columns_mobile;
    const feature_card_enabled = this.dataset.feature_card_enabled === 'true';
    if( feature_card_enabled ) {
      cards_fit_desktop = sliderUL.children.length < columns_desktop;
    }else{
      cards_fit_desktop = sliderUL.children.length <= columns_desktop
    }


    if( cards_fit_desktop ) {
      sliderComponent.classList.add('slider-component--cards-fit-desktop');
    }else{
      sliderComponent.classList.remove('slider-component--cards-fit-desktop');
    }

    if( cards_fit_mobile ) {
      sliderComponent.classList.add('slider-component--cards-fit-mobile');
    }else{
      sliderComponent.classList.remove('slider-component--cards-fit-mobile');
    }

    if( featureWrap ) {
      if( cards_fit_desktop ) {
        featureWrap.classList.add('carousel__feature-wrap--cards-fit-desktop');
      }else{
        featureWrap.classList.remove('carousel__feature-wrap--cards-fit-desktop');
      }
    }

    if( this.dataset.full_width === 'true' ) {
      // set full_width class on parent
      sliderComponent.classList.add('slider-component-full-width');
      sliderComponent.classList.remove('page-width');

      // Add dummy list items for padding
      const li = document.createElement('li');
      li.setAttribute('aria-hidden', 'true');
      li.setAttribute('class', 'slider__slide first-dummy');
      li.innerHTML = '<!--fake padding-->';

      const li_2 = document.createElement('li');
      li_2.setAttribute('aria-hidden', 'true');
      li_2.setAttribute('class', 'slider__slide last-dummy');
      li_2.innerHTML = '<!--fake padding-->';

      sliderUL.prepend(li);
      sliderUL.appendChild(li_2);
    } else {
      sliderComponent.classList.remove('slider-component-full-width');
      sliderComponent.classList.add('page-width');
    }

    sliderUL.scrollLeft = 0;
    this.classList.add('recently-viewed--loaded');

  };

  getRecentProducts = async () => {
    let searchRecentlyUrl;
    let productHandle;

    if (window.location.pathname.indexOf('/products/') !== -1) {
      productHandle = window.location.pathname.match(
        /\/products\/([a-z0-9\-]+)/
      )[1];
      this.productHandleQueue = this.productHandleQueue.filter(handle => productHandle !== handle);
    }

    if (this.productHandleQueue.length < this.config.minToShow) {
      return;
    }
    this.config.numberProducts = this.productHandleQueue.length;

    this.productHandleQueue.length = this.config.maxToShow;
    searchRecentlyUrl = '/search?view=ua_recently-viewed&q=' + this.productHandleQueue.toString();
    await fetch(searchRecentlyUrl).then(response =>
      response.text()
    ).then(html => {
      document.querySelector(`#shopify-section-${ this.dataset.sectionid } recently-viewed`).innerHTML = html;
      this.finalize();
    }).catch(err => {
      console.warn('Something went wrong.', err);
    });

  };

  recordRecentlyViewed = values => {
    let vals = values || {};
    let recentlyViewed = this.cookie.read();
    let productHandle;
    let position;

    // Update defaults.
    this.config = {...this.config, ...vals};

    // If we are on a product page.
    if (window.location.pathname.indexOf('/products/') !== -1) {

      productHandle = window.location.pathname.match(
        /\/products\/([a-z0-9\-]+)/
      )[1];

      position = recentlyViewed.indexOf(productHandle);

      if (position === -1) {

        recentlyViewed.unshift(productHandle);

        recentlyViewed = recentlyViewed.splice(
          0,
          this.config.howManyToStoreInMemory
        );
      } else {

        recentlyViewed.splice(position, 1);
        recentlyViewed.unshift(productHandle);
      }

      this.cookie.write(recentlyViewed);
    }
  }

  showRecentlyViewed = parameters => {

    // Hide whole carousel if only tab and nothing to show
    const recently_is_only_tab = this.dataset.recently_is_only_tab === 'true';
    const sectionid = this.dataset.section_id;
    const carousel = document.querySelector('.carousel.section-'+sectionid);
    const product_handles_list = localStorage.getItem("shopify_recently_viewed");
    if( this.dataset.on_product_page === 'true' ) {
      const product_handle = this.dataset.product_handle;
      const no_recently_viewed = ( !product_handles_list || product_handles_list == "" || product_handles_list == product_handle );
      if( recently_is_only_tab && no_recently_viewed && carousel) {
        carousel.classList.add('hidden');
      } else {
        const no_recently_viewed = ( !product_handles_list || product_handles_list == "" );
        if( recently_is_only_tab && no_recently_viewed && carousel) {
          carousel.classList.add('hidden');
        }
      }
    }


    let params = parameters || {};
    // Update defaults.
    this.config = {...this.config, ...params};

    // Read cookie.
    this.productHandleQueue = this.cookie.read();

    if (this.productHandleQueue === null || this.productHandleQueue === undefined) {
      return false;
    }

    this.config.maxToShow = Math.min(this.productHandleQueue.length, this.config.maxToShow);

    if (this.config.maxToShow) {
      this.getRecentProducts().then();
    }
  }

  connectedCallback() {
    this.showRecentlyViewed();
    this.recordRecentlyViewed();
  }
}

customElements.define('recently-viewed', RecentlyViewed);


// COMMENTING OUT FOR PERFORMANCE REASONS - KEEPING THE CODE IN CASE WE WANT TO RE-ENABLE LATER

// class productCardGallery extends HTMLElement {
//   constructor() {
//     super();
//     this.addEventListener('mouseover', this.LoadImages.bind(this));

//     let observerOptions = {
//       root: null,
//       rootMargin: "0px",
//       threshold: 0.25
//     };
//     this.observer = new IntersectionObserver(this.handleIntersection, observerOptions);
//   }
//   connectedCallback() {
//     if (('ontouchstart' in window) ||
//       (navigator.maxTouchPoints > 0) ||
//       (navigator.msMaxTouchPoints > 0) ) {
//       this.observer.observe(this);
//     }

//     this.LoadImages();
//   }
//   addAnimation() {
//     this.querySelector('.gallery-slider').classList.add('gallery-animation');
//   }
//   handleIntersection(entries) {
//     entries.forEach(entry => {
//       if (entry.intersectionRatio > 0) {
//         entry.target.LoadImages();
//       }
//     });
//   }

//   LoadImages() {
//     if (!this.classList.contains('loaded')) {
//       this.querySelectorAll('img').forEach(image => {
//         image.src = image.dataset.src;
//       });
//       this.classList.add('loaded');
//     }
//   }
// }

// customElements.define('product-card-gallery', productCardGallery);

class CustomSelect extends HTMLElement {
  constructor() {
    super();

    this.mainSelect = this.querySelector("select");
    this.mainLabel = this.querySelector("label");
    this.selectStyle = this.dataset.style || 'default';
    this.selectType = this.dataset.type || 'default';
    this.randomId = Math.random().toString(36).substring(7);

    this.selectTemplate = document.createElement("template");

    if(this.selectType === 'default') {
    this.selectTemplate.innerHTML = `
      <div id="select-${this.randomId}" class="custom-select style-${this.selectStyle}" tabindex="0" >
        <div class="select-selected" aria-role="button" aria-controls="select-${this.randomId}" aria-expanded="false"  aria-controls="select-options-${this.randomId}" >
          <div class="select-label"></div>
          <div class="selected-item"></div>
          <div class="select-arrow">
            <svg aria-hidden="true" focusable="false" class="icon icon-caret icon-custom-select-arrow" viewBox="0 0 10 6">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
            </svg>
          </div>
        </div>
        <div id="select-options-${this.randomId}" class="select-items select-hide" role="listbox"></div>
      </div>
    `;
    } else if (this.selectType === 'collection-sort') {
      this.selectTemplate.innerHTML = `
      <div id="select-${this.randomId}" class="custom-select style-${this.selectStyle}" tabindex="0" >
        <div class="select-selected" aria-role="button" aria-controls="select-${this.randomId}" aria-expanded="false"  aria-controls="select-options-${this.randomId}" >
          <div class="select-label"></div>
          <div class="selected-item"></div>
          <div class="select-arrow">
            <svg aria-hidden="true" focusable="false" class="icon icon-caret icon-custom-select-arrow" viewBox="0 0 10 6">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
            </svg>
          </div>
        </div>
        <div id="select-options-${this.randomId}" class="select-items select-hide" role="listbox"></div>
      </div>
    `;
    }
  }

  connectedCallback() {
    this.select = this.selectTemplate.content.cloneNode(true);
    this.appendChild(this.select);

    this.dropdownContainer = this.querySelector(".select-items");
    this.selectSelected = this.querySelector(".select-selected");
    this.selectedItem = this.querySelector(".selected-item");
    this.customSelect = this.querySelector(".custom-select");

    // populate options
    this.populateOptions();
    // populate label if exists
    if(this.mainLabel) {
      this.populateLabel();
    }

    this.selectItems = this.querySelectorAll(".select-item");
    // set initial selected item
    this.initialSelectItem();

    this.selectSelected.addEventListener("click", () => this.toggleDropdown());
    document.addEventListener("click", (event) => this.bodyClickHandler(event));
    this.addEventListener("keyup", (event) => this.closeOnEscKey(event));
    this.addEventListener("keyup", (event) => this.openOnFocusAndEnter(event));

    //check if any item inside dropdown is focused, if not close
    this.dropdownContainer.addEventListener("focusout", (event) => {
      if (!this.contains(event.relatedTarget)) {
        this.dropdownContainer.classList.add("select-hide");
        this.removeTabIndexFromAllSelectItems();
        // set aria-expanded to false when dropdown is closed
        this.selectSelected.setAttribute("aria-expanded", "false");
      }
    });

    this.customSelect.addEventListener("focus", () => {
      this.dropdownContainer.classList.add("select-hide");
      this.removeTabIndexFromAllSelectItems();
    });
  }

  createOptionHTML(option) {
    if (!option) return '';

    if (option.includes(' - ')) {
      const optionParts = option.split(' - ');

      return `
        ${optionParts[0] ? `<span class="select-item-option-part select-item-option-part--1">${optionParts[0]}</span>` : ''}
        ${optionParts[1] ? `<span class="select-item-option-part select-item-option-part--2">${optionParts[1]}</span>` : ''}
      `;
    }

    return option;
  }

  populateOptions() {
    // loop through options and create select items
    let selectItem;
    this.mainSelect.querySelectorAll("option").forEach((option) => {
      selectItem = document.createElement("div");

      selectItem.innerHTML = this.createOptionHTML(option.innerText);

      selectItem.classList.add("select-item");

      if (option.classList.contains("shoppable-market")) {
        selectItem.classList.add("shoppable-market");
      }

      selectItem.setAttribute("role", "option");
      selectItem.setAttribute("aria-selected", "false");

      if (option.selected) {
        selectItem.classList.add("selected");
        selectItem.setAttribute("aria-selected", "true");
      }

      this.dropdownContainer.appendChild(selectItem);

      // if option is disabled add disabled class and return
      if(option.disabled) {
        selectItem.classList.add("disabled");
        return;
      }

      selectItem.addEventListener("click", () => this.onSelectItem(option, selectItem));
      // onSelect when enter key pressed and focused
      selectItem.addEventListener("keyup", (event) => {
        if (event.key === "Enter" && option.innerHTML == document.activeElement.innerHTML) {
          this.onSelectItem(option, selectItem);
        }
      });

    });
  }

  onSelectItem(option) {
    if (option.dataset.variantUrl) {
      return window.location = option.dataset.variantUrl;
    }

    // update selected item
    this.selectedItem.innerHTML = this.createOptionHTML(option.innerText);
    // remove selected class from all select items
    const selectedOption = this.querySelector("[selected]");
    if(selectedOption) {
      selectedOption.removeAttribute("selected");
    }

    this.selectItems.forEach((item) => item.classList.remove("selected"));
    // add selected class to the clicked item
    this.selectItems[option.index].classList.add("selected");
    // set aria-selected to false for all items
    this.selectItems.forEach((item) => item.setAttribute("aria-selected", "false"));
    // set aria-selected to true for the clicked item
    this.selectItems[option.index].setAttribute("aria-selected", "true");

    // update original select and dispatch change event
    this.mainSelect.selectedIndex = option.index;
    if(this.mainSelect.options[option.index].classList.contains("shoppable-market")) {
      this.selectedItem.classList.add("shoppable-market");
    } else {
      this.selectedItem.classList.remove("shoppable-market");
    }
    this.mainSelect.options[option.index].setAttribute("selected", "selected");
    this.mainSelect.dispatchEvent(new Event("change"));

    this.removeTabIndexFromAllSelectItems();
    this.dropdownContainer.classList.add("select-hide");

    const variantSelect = this.closest("variant-selects");
    if (variantSelect) variantSelect.onVariantChange();
  }

  populateLabel() {
    this.selectLabel = this.querySelector(".select-label");
    this.selectLabel.innerHTML = this.mainLabel.innerHTML;
  }

  initialSelectItem() {
    this.selectedItem.innerHTML = this.createOptionHTML(this.mainSelect.options[this.mainSelect.selectedIndex].innerText);

    if(this.mainSelect.options[this.mainSelect.selectedIndex].classList.contains("shoppable-market")) {
      this.selectedItem.classList.add("shoppable-market");
    }
  }

  toggleDropdown() {
    this.dropdownContainer.classList.toggle("select-hide");
    if (!this.dropdownContainer.classList.contains("select-hide")) {
      this.moveFocusToFirsItem();
      // set aria-expanded to true when dropdown is open
      this.selectSelected.setAttribute("aria-expanded", "true");
    } else {
      this.customSelect.focus();
      // set aria-expanded to false when dropdown is closed
      this.selectSelected.setAttribute("aria-expanded", "false");
    }
  }

  bodyClickHandler(event) {
    if (!this.contains(event.target)) {
      this.dropdownContainer.classList.add("select-hide");
      // set aria-expanded to false when dropdown is closed
      this.selectSelected.setAttribute("aria-expanded", "false");
    }
  }

  closeOnEscKey(event) {
    if (event.key === "Escape") {
      this.dropdownContainer.classList.add("select-hide");
      this.removeTabIndexFromAllSelectItems();
      this.customSelect.focus();
      // set aria-expanded to false when dropdown is closed
      this.selectSelected.setAttribute("aria-expanded", "false");
    }
  }

  moveFocusToFirsItem() {
    // focus first of currently selected item
    if(this.mainSelect.selectedIndex){
      this.selectItems[this.mainSelect.selectedIndex].focus();
    } else {
      this.selectItems[0].focus();
    }
  }

  addTabIndexToAllSelectItems() {
    this.selectItems.forEach((item) => item.setAttribute("tabindex", "0"));
  }

  removeTabIndexFromAllSelectItems() {
    this.selectItems.forEach((item) => item.removeAttribute("tabindex"));
  }

  openOnFocusAndEnter(event) {
    // open dropdown on focus and enter key
    if (event.key === "Enter" && this.dropdownContainer.classList.contains("select-hide") && this.customSelect === document.activeElement) {
      this.dropdownContainer.classList.remove("select-hide");
      this.moveFocusToFirsItem();
      this.addTabIndexToAllSelectItems();
      // set aria-expanded to true when dropdown is open
      this.selectSelected.setAttribute("aria-expanded", "true");
    }
  }
}

customElements.define("custom-select", CustomSelect);

class SizeDrawer extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector('.section-header');
    this.annBar = document.querySelector('.announcement-bar-section');
    this.trigger = document.querySelector('size-drawer-trigger');
    this.closeButton = this.querySelector('.size-drawer__close');
    this.overlay = document.querySelector('.size-drawer-overlay');
    this.chatButton = document.querySelector('#chat-button') || undefined;
  }

  connectedCallback() {
    this.trigger.addEventListener('click', () => this.open());
    this.closeButton.addEventListener('click', () => this.close());
    this.overlay.addEventListener('click', () => this.close());
    // close on escape key when is opened
    document.addEventListener('keyup', (event) => {
      if (event.key === 'Escape' && this.classList.contains('open')) {
        this.close();
      }
    });
  }

  open() {
    this.chatButton = document.querySelector('#chat-button') || undefined;
    this.classList.add('open');
    this.overlay.classList.add('open');
    this.header.classList.add('shopify-section-header-hidden');
    if (this.annBar) this.annBar.style.zIndex = '0';
    console.log(this.chatButton)
    if (this.chatButton) this.chatButton.classList.add('chat-button-hide');
    this.header.style.zIndex = '0';
    setTimeout(() => {
      document.body.style.overflow = 'hidden';
    }, 300);
  }

  close() {
    this.classList.remove('open');
    this.overlay.classList.remove('open');
    setTimeout(() => {
      document.body.style.overflow = '';
      this.header.style.zIndex = '3';
      if (this.annBar) this.annBar.style.zIndex = '4';
      if (this.chatButton) this.chatButton.classList.remove('chat-button-hide');
    }, 300);
  }

}

customElements.define('size-drawer', SizeDrawer);

window.handleize = str => {
  str = str.trim() // remove whitespace from string
  str = str.toLowerCase() // Set to lowercase
  str = str.replace(/\s+/g, '-') // Replace spaces
  str = str.replace(/&/g, '-') // Replace ampersands
  str = str.replace(/----/g, '-') // Replace four dashes
  str = str.replace(/---/g, '-') // Replace triple dashes
  str = str.replace(/--/g, '-') // Replace double dashes
  str = str.replace(/"/g, '') // Removed double quotes
  return str;
}